/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/visualization.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiVisualizationType } from './ApiVisualizationType';
import {
  ApiVisualizationTypeFromJSON,
  ApiVisualizationTypeFromJSONTyped,
  ApiVisualizationTypeToJSON,
  ApiVisualizationTypeToJSONTyped,
} from './ApiVisualizationType';

/**
 *
 * @export
 * @interface ApiVisualization
 */
export interface ApiVisualization {
  /**
   *
   * @type {ApiVisualizationType}
   * @memberof ApiVisualization
   */
  type?: ApiVisualizationType;
  /**
   * Path pattern of input data to be used during generation of visualizations.
   * This is required when creating the pipeline through CreateVisualization
   * API.
   * @type {string}
   * @memberof ApiVisualization
   */
  source?: string;
  /**
   * Variables to be used during generation of a visualization.
   * This should be provided as a JSON string.
   * This is required when creating the pipeline through CreateVisualization
   * API.
   * @type {string}
   * @memberof ApiVisualization
   */
  arguments?: string;
  /**
   * Output. Generated visualization html.
   * @type {string}
   * @memberof ApiVisualization
   */
  html?: string;
  /**
   * In case any error happens when generating visualizations, only
   * visualization ID and the error message are returned. Client has the
   * flexibility of choosing how to handle the error.
   * @type {string}
   * @memberof ApiVisualization
   */
  error?: string;
}

/**
 * Check if a given object implements the ApiVisualization interface.
 */
export function instanceOfApiVisualization(value: object): value is ApiVisualization {
  return true;
}

export function ApiVisualizationFromJSON(json: any): ApiVisualization {
  return ApiVisualizationFromJSONTyped(json, false);
}

export function ApiVisualizationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiVisualization {
  if (json == null) {
    return json;
  }
  return {
    type: json['type'] == null ? undefined : ApiVisualizationTypeFromJSON(json['type']),
    source: json['source'] == null ? undefined : json['source'],
    arguments: json['arguments'] == null ? undefined : json['arguments'],
    html: json['html'] == null ? undefined : json['html'],
    error: json['error'] == null ? undefined : json['error'],
  };
}

export function ApiVisualizationToJSON(json: any): ApiVisualization {
  return ApiVisualizationToJSONTyped(json, false);
}

export function ApiVisualizationToJSONTyped(
  value?: ApiVisualization | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    type: ApiVisualizationTypeToJSON(value['type']),
    source: value['source'],
    arguments: value['arguments'],
    html: value['html'],
    error: value['error'],
  };
}
